
function scrollToLetter(letter) {
    window.scrollTo({
        top: document.getElementById(letter).offsetTop,
        behavior: 'smooth'
    })
}

function initializeBrandingNav() {
    const mainHeader = document.querySelector('.shopify-section-header');
    const navWrapper = document.querySelector('.brand-nav-wrapper');
    const navList = document.querySelector('.brand-nav');
    const leftBtn = document.querySelector('.nav-btn.left');
    const rightBtn = document.querySelector('.nav-btn.right');
    const navOffset = navWrapper.offsetTop;

    /** make brand nav sticky to top */
    function setBrandNavPos () {
        if (navWrapper.dataset.fixed !== 'true') return 
        if (window.scrollY >= navOffset) {
        navWrapper.style.top = mainHeader.offsetHeight + 'px'
        navWrapper.classList.add('brand-nav-wrapper--fixed');
        } else {
            navWrapper.classList.remove('brand-nav-wrapper--fixed');
            navWrapper.style.top = 0
        }
    }

    /** hide or show left-right buttons */
    function checkOverflow() {
        const scrollWidth = navList.scrollWidth;
        const clientWidth = navList.clientWidth;

        if (scrollWidth > clientWidth) {
            leftBtn.style.display = 'block';
            rightBtn.style.display = 'block';
            navList.parentNode.style.padding = '0 50px';
        } else {
            leftBtn.style.display = 'none';
            rightBtn.style.display = 'none';
            navList.parentNode.style.padding = '0';
        }
    }

    /** manually scroll the brand list menu */
    function scrollNav(amount) {
        navList.scrollLeft += amount;
    }

    window.addEventListener('scroll', () => {
        setBrandNavPos()  
    });

    window.addEventListener('resize', checkOverflow);

    setBrandNavPos();
    checkOverflow();
    leftBtn.addEventListener('click', function() {
        scrollNav(-200);
    });
    rightBtn.addEventListener('click', function() {
        scrollNav(200);
    });
}


document.addEventListener("DOMContentLoaded", function () {
    initializeBrandingNav()
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
        setTimeout(function () {
            initializeBrandingNav()
        }, 500);
    });
}
